// extracted by mini-css-extract-plugin
export default {"card":"CatalogItemSkeleton_card__8BlE0","load":"CatalogItemSkeleton_load__GapCk"};